import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Dimensions, Platform, StyleSheet } from 'react-native';
import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { SalesRepDetails } from '@/components/sales-rep/sales-rep-details';
import { UpdateQuantityFn } from '@/contexts/new-order-actions-context-types';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  itemMetadata: ItemListOptionMetadata;
  onClose: () => void;
  onSalesRepPriceUpdated?: () => void;
  updateQuantity?: UpdateQuantityFn;
}

export const DSRToolingActionSheet: React.FC<Props> = ({
  itemMetadata,
  onClose,
  onSalesRepPriceUpdated,
  updateQuantity,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const isMobileWeb = isSmallLayout && Platform.OS === 'web';
  return (
    <BaseActionSheet
      contentStyle={isMobileWeb ? styles.mobileWebContent : undefined}
      displayCloseButtonOverride={isMobileWeb}
      isVisible
      modalHeaderStyle={isMobileWeb ? styles.mobileWebHeaderButton : undefined}
      onClose={onClose}
      onModalCloseButtonPress={onClose}
      title={!isMobileWeb ? i18n.t('edit_price') : undefined}
    >
      <SalesRepDetails
        containerStyle={isMobileWeb ? styles.containerStyle : undefined}
        itemMetadata={itemMetadata}
        onSalesRepPriceUpdated={onSalesRepPriceUpdated}
        updateQuantity={updateQuantity}
      />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  containerStyle: {
    padding: 0,
  },
  mobileWebContent: {
    // ~90% maxHeight is needed since the modal takes the full screen height
    maxHeight: Dimensions.get('window').height * 0.9,
    paddingTop: 0,
  },
  mobileWebHeaderButton: {
    // overriding the default padding for modalHeaderStyle
    paddingHorizontal: 0,
    paddingVertical: 16,
  },
});
